__turbopack_context__.v({
  "active": "Menu-module-scss-module__g4tVyW__active",
  "app_light_theme": "Menu-module-scss-module__g4tVyW__app_light_theme",
  "li": "Menu-module-scss-module__g4tVyW__li",
  "ul": "Menu-module-scss-module__g4tVyW__ul",
});
